import { IPersonaProps } from '../../../../Persona';

export const people: IPersonaProps[] = [
    {
      key: 0,
      imageUrl: './images/persona-female.png',
      imageInitials: 'PV',
      primaryText: 'Annie Lindqvist',
      secondaryText: 'Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 1,
      imageUrl: './images/persona-male.png',
      imageInitials: 'AR',
      primaryText: 'Aaron Reid',
      secondaryText: 'Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 2,
      imageUrl: './images/persona-male.png',
      imageInitials: 'AL',
      primaryText: 'Alex Lundberg',
      secondaryText: 'Software Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 3,
      imageUrl: './images/persona-male.png',
      imageInitials: 'RK',
      primaryText: 'Roko Kolar',
      secondaryText: 'Financial Analyst',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 4,
      imageUrl: './images/persona-male.png',
      imageInitials: 'CB',
      primaryText: 'Christian Bergqvist',
      secondaryText: 'Sr. Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 5,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Valentina Lovric',
      secondaryText: 'Design Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 6,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Maor Sharett',
      secondaryText: 'UX Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 7,
      imageUrl: './images/persona-female.png',
      imageInitials: 'PV',
      primaryText: 'Annie Lindqvist2',
      secondaryText: 'Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 8,
      imageUrl: './images/persona-male.png',
      imageInitials: 'AR',
      primaryText: 'Aaron Reid2',
      secondaryText: 'Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 9,
      imageUrl: './images/persona-male.png',
      imageInitials: 'AL',
      primaryText: 'Alex Lundberg2',
      secondaryText: 'Software Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 10,
      imageUrl: './images/persona-male.png',
      imageInitials: 'RK',
      primaryText: 'Roko Kolar2',
      secondaryText: 'Financial Analyst',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 11,
      imageUrl: './images/persona-male.png',
      imageInitials: 'CB',
      primaryText: 'Christian Bergqvist2',
      secondaryText: 'Sr. Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 12,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Valentina Lovric2',
      secondaryText: 'Design Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 13,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Maor Sharett2',
      secondaryText: 'UX Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 14,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Another A Name',
      secondaryText: 'Extra',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 15,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Another A Name (So Many A names!)',
      secondaryText: 'Extra extra',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 16,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Another Anecdotal A Name',
      secondaryText: '3 extra',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 17,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Anerobic A Name',
      secondaryText: 'Lifts Weights',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 18,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Aerobic A Name',
      secondaryText: 'Runs a lot',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 13,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Maor Sharett2',
      secondaryText: 'UX Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 12,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Valentina Lovric2',
      secondaryText: 'Design Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 13,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Maor Sharett2',
      secondaryText: 'UX Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
        {
      key: 12,
      imageUrl: './images/persona-female.png',
      imageInitials: 'VL',
      primaryText: 'Valentina Lovric2',
      secondaryText: 'Design Developer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
    {
      key: 13,
      imageUrl: './images/persona-male.png',
      imageInitials: 'MS',
      primaryText: 'Maor Sharett2',
      secondaryText: 'UX Designer',
      tertiaryText: 'In a meeting',
      optionalText: 'Available at 4:00pm'
    },
  ];
